import React, { Fragment } from 'react';
import { Column, Row } from '../../components/Grid';
import { Header } from '../../components/Header';
import { Section } from '../../components/Section';
import { withErrorBoundary } from '../../error-handling/withErrorBoundary';
import {
  selectIsPathContentLoaded,
  selectMenu,
  selectSysLanguageIsocode
} from '../../provider/Typo3Provider/selectors';
import {
  withTypo3,
  WithTypo3Props
} from '../../provider/Typo3Provider/withTypo3';
import LogoContainer from './LogoContainer';
import MetaNavigationContainer from './MetaNavigationContainer';
import NavigationContainer from './NavigationContainer';

import { Claim } from '../../components/Claim';
import { Logo } from '../../components/Logo';
import { SvgIcon } from '../../components/SvgIcon';
import {AnniversaryLogo} from "../../components/AnniversaryLogo";

interface HeaderContainerProps {}

const HeaderContainer = ({ typo3 }: HeaderContainerProps & WithTypo3Props) => {
  if (!selectIsPathContentLoaded(typo3)) {
    return null;
  }

  const [rootPage = null] = selectMenu(typo3, 'rootpage');
  const sysLanguageIsocode = selectSysLanguageIsocode(typo3);

  return (
    <Fragment>
      <Header className="hide-for-print">
        <MetaNavigationContainer />
        <Row noGap alignItems="flex-end">
          <Column large={12}>
            <Section>
              <Row>
                <Column large={4}>
                  <LogoContainer root={rootPage || undefined} />
                </Column>
                <Column large={8}>
                  <Claim className="hide-for-small">
                    {sysLanguageIsocode === 'fr'
                      ? 'Contrôlés. Testés. Validés.'
                      : 'Tried.Tested.Trusted.'}
                  </Claim>
                </Column>
                {/* <AnniversaryLogo /> */}
              </Row>
            </Section>
          </Column>
          <Column large={12}>
            <NavigationContainer />
          </Column>
        </Row>
      </Header>
      <Logo className="show-for-print">
        <SvgIcon icon={'logo'} />
      </Logo>
    </Fragment>
  );
};

export default withErrorBoundary(withTypo3(HeaderContainer), 'HeaderContainer');
